import { LoadState } from './data-loading.types';

// Helper functions for LoadState

export const isItemLoading = (state?: LoadState): boolean =>
  state === LoadState.Loading || state === LoadState.Reloading;

export const isItemLoadingOrLoaded = (state: LoadState): boolean =>
  state === LoadState.Loading ||
  state === LoadState.Reloading ||
  state === LoadState.LoadComplete;
